import { Link } from "react-router-dom";
import { platformStats } from "@/mocks/streams";

export default function PlatformIntro() {
  return (
    <section className="w-full rounded-xl border border-background-200/70 bg-background-100 px-5 py-10 md:px-10 md:py-14">
      <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:items-center">
        <div>
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/12 px-3 py-1 text-xs text-primary-500">
            <span className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-broadcast-line"></i>
            </span>
            关于有因直播
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
            丰富多彩的直播内容
            <br />
            精彩互动尽在这里
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-500">
            有因直播为用户提供涵盖游戏、娱乐、生活、音乐、户外、科技、美食、体育等领域的实时直播内容。
            我们相信每一次直播都是一次真实的相遇，无论你是想观看高清直播、参与实时互动，还是想分享自己的生活，
            都能在这里找到属于你的舞台。
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-3">
            <Link
              to="/about"
              className="rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              了解更多
            </Link>
            <Link
              to="/contact"
              className="rounded-md border border-background-300 px-5 py-2.5 text-sm text-foreground-700 transition-colors hover:border-primary-400 hover:text-primary-500 whitespace-nowrap"
            >
              成为合作主播
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          {platformStats.map((stat) => (
            <div key={stat.id} className="rounded-lg border border-background-200/70 bg-background-50 p-5">
              <p className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{stat.value}</p>
              <p className="mt-2 text-sm text-foreground-400">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}